import { parseCloudRun } from './parseCloud'

/** Cloud's answer for an internal meeting link (`getMeetingLinkStatus`). */
export type MeetingLinkStatus = 'ok' | 'removed' | 'cancelled' | 'ended' | 'not-found'

const KNOWN: readonly MeetingLinkStatus[] = ['ok', 'removed', 'cancelled', 'ended', 'not-found']

/** Same wording external guests get on their join page, so both audiences read the same. */
const REFUSALS: Partial<Record<MeetingLinkStatus, string>> = {
  removed: "You're not on the invite list for this meeting.",
  cancelled: 'This meeting has been cancelled by the organiser.',
  ended: 'This meeting has ended.',
}

/**
 * The notice for a meeting link that must not take the user into the room, or null to go ahead.
 * `not-found` goes ahead: the link still names a room, and joining it was never meeting-gated.
 */
export function meetingLinkRefusal(status: MeetingLinkStatus): string | null {
  return REFUSALS[status] ?? null
}

/**
 * Fails open: an error or an unexpected answer reads as `ok`, so a cloud hiccup or a cloud
 * without this function never keeps an invitee out of their meeting.
 */
export async function fetchMeetingLinkStatus(bookingId: string): Promise<MeetingLinkStatus> {
  try {
    const result = await parseCloudRun<{ status?: unknown }>('getMeetingLinkStatus', { bookingId })
    const status = result?.status
    return KNOWN.includes(status as MeetingLinkStatus) ? (status as MeetingLinkStatus) : 'ok'
  } catch (error) {
    console.warn('[MeetingLink] Status check failed; opening the room as before:', error)
    return 'ok'
  }
}
